import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Composition from './Composition';
import ClientProvider from './client';
export default createDemo(import.meta.url, Composition, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/guides/composition/demos/composition/Composition.tsx",
    "fileName": "Composition.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import IconButton from '@mui/material/IconButton';\nimport Icon from '@mui/material/Icon';\nimport type { IconProps } from '@mui/material/Icon';\n\nfunction WrappedIcon(props: IconProps) {\n  return <Icon {...props} />;\n}\nWrappedIcon.muiName = 'Icon';\n\nexport default function Composition() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <IconButton>\n        <Icon>alarm</Icon>\n      </IconButton>\n      <IconButton>\n        <WrappedIcon>alarm</WrappedIcon>\n      </IconButton>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 21,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import IconButton from '@mui/material/IconButton';\nimport Icon from '@mui/material/Icon';\nimport type { IconProps } from '@mui/material/Icon';\n\nfunction WrappedIcon(props: IconProps) {\n  return <Icon {...props} />;\n}\nWrappedIcon.muiName = 'Icon';\n\nexport default function Composition() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <IconButton>\n        <Icon>alarm</Icon>\n      </IconButton>\n      <IconButton>\n        <WrappedIcon>alarm</WrappedIcon>\n      </IconButton>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              ">alarm</",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "WrappedIcon"
              ],
              ">alarm</",
              [
                "span",
                "pl-c1 di-jsx",
                "WrappedIcon"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "IconButton"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 21,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "@mui/material/IconButton",
      "@mui/material/Icon"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
